import { http } from '../../../../api/http';
import type { ComisionVendedor } from '../types/comision.types';

export class ComisionService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/comision',
  };

  public static async getAll(): Promise<ComisionVendedor[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching comisiones:', error);
      throw error;
    }
  }

  public static async getByVendedor(idVendedor: number): Promise<ComisionVendedor[]> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/vendedor/${idVendedor}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching comisiones vendedor:', error);
      throw error;
    }
  }

  public static async calcular(fechaDesde?: string, fechaHasta?: string): Promise<ComisionVendedor[]> {
    try {
      const params: any = {};
      if (fechaDesde) params.fechaDesde = fechaDesde;
      if (fechaHasta) params.fechaHasta = fechaHasta;

      const response = await http.post(`${this.ENDPOINTS.BASE}/calcular`, null, { params });
      return response.data;
    } catch (error) {
      console.error('Error calculando comisiones:', error);
      throw error;
    }
  }
}
